import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseFillDataFormComponent} from '../base-fill-data-form-component';
import {FormGroup} from '@angular/forms';
import {SalaryType} from '../../../enums/salary-type.enum';
import {SalaryMode} from '../../../enums/salary-mode.enum';

@Component({
  selector: 'app-salary-range-input',
  templateUrl: './salary-range-input.component.html'
})
export class SalaryRangeInputComponent extends BaseFillDataFormComponent implements OnInit {
  @Input() name: string;
  @Input() nameMax: string;
  @Input() label: string;
  @Input() formGroup: FormGroup;
  @Output() onSalaryChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onMaxSalaryChange: EventEmitter<any> = new EventEmitter<any>();

  salaryTypes: SalaryType[];
  salaryModes: SalaryMode[];

  ngOnInit() {
    this.salaryTypes = SalaryType.getSalaryTypes();
    this.salaryModes = SalaryMode.getSalaryModes();
  }

  salaryChanged(event) {
    this.onSalaryChange.emit(event);
  }

  maxSalaryChanged(event) {
    this.onMaxSalaryChange.emit(event);
  }

  showValidateError(): boolean {
    let min = this.formGroup.get(this.name).value;
    let max = this.formGroup.get(this.nameMax).value;
    if (min !== null && min !== undefined && max !== null && max !== undefined) {
      return parseFloat(min.toString().replace(',', '.')) > parseFloat(max.toString().replace(',', '.'));
    }
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/salary-range-input/salary-range-input.component.ts